import React, { useState, useRef, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Dialog, Transition } from "@headlessui/react";
import Input from "../../inputs/inputs";
import Button from "../../buttons/buttons";
import CLOSE from "../../../assets/images/icons/close.svg";
import { ReactComponent as UploadIcon } from "../../../assets/images/icons/upload.svg";
import { Beat } from "../../../plugins/spinners.plugin";
import { cleanInput } from "../../../helpers/cleanInput";
import { history } from "../../../helpers/history";
import { editAdvertisment } from "../../../redux/advertisment/advertismentAction";

export default function EditSlider({ advert }) {
  const dispatch = useDispatch();
  const hiddenFileInput = useRef(null);
  const [submitted, setSubmitted] = useState(false);
  const [images, setImages] = useState([]);
  const [imageUrls, setImageUrls] = useState([]);
  const [image64, setImage64] = useState({});
  const { isLoading } = useSelector((state) => state.advertisment);
  let [isOpen, setIsOpen] = useState(false);
  function handleClose() {
    setIsOpen(false);
  }
  const [data, setData] = useState({
    id: advert.id,
    title: "",
    url: "",
    description: "",
    base64_photos: "",
  });
  const { title, url } = data;

  function onImageChange(e) {
    setImages([...e.target.files]);
    let reader = new FileReader();
    reader.readAsDataURL(e.target.files[0]);
    reader.onloadend = () => {
      setImage64(reader.result);
    };
  }
  const handleFileClick = (event) => {
    event.preventDefault();
    hiddenFileInput.current.click();
  };
  useEffect(() => {
    // Update the document title using the browser API
    let dataObject = {
      title: advert?.title,
      url: advert?.url,
      description: advert?.description,
    };

    setData({ ...dataObject });
  }, [advert]);

  useEffect(() => {
    if (images.length < 1) return;
    const newImageUrls = [];
    images.forEach((image) => newImageUrls.push(URL.createObjectURL(image)));
    setImageUrls(newImageUrls);
  }, [images]);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setData((data) => ({ ...data, [name]: value }));
  };
  const handleSubmit = async () => {
    const newData = { ...data, base64_photos: [image64] };
    cleanInput(newData);
    setSubmitted(true);
    if (title && url) {
      // dispatch action to create data
      const response = await dispatch(
        editAdvertisment({ ...data, id: advert.id })
      );
      if (response?.status === "success") {
        history("/admin/settings/sliders/1");
        handleClose();
      }
    }
  };
  return (
    <div>
      <Button.Primary title={"Edit Slider"} onClick={() => setIsOpen(true)} />
      <Transition appear show={isOpen}>
        <Dialog as="div" className="relative z-10" onClose={handleClose}>
          <Transition.Child
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>

          <div className="fixed z-10 inset-0 overflow-y-auto">
            <div className="flex items-center sm:items-center justify-center min-h-full p-4 text-center sm:p-0">
              <Transition.Child
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <Dialog.Panel className=" bg-white w-[380px] text-left sm:w-[630px] p-4 sm:p-6">
                  <div>
                    <div className=" sm:block absolute top-3 right-2 pt-4 pr-4">
                      <button
                        type="button"
                        className="bg-[#ffeae5] rounded-md p-1 sm:p-3 "
                        onClick={handleClose}
                      >
                        <span className="sr-only">Close</span>
                        <img
                          src={CLOSE}
                          alt="close"
                          className=" w-3 h-3 sm:w-4 sm:h-4"
                        />
                      </button>
                    </div>

                    <div className="pb-5 text-center sm:mt-2 sm:text-center border-b border-[#E4E4F3]">
                      <Dialog.Title
                        as="h3"
                        className="text-xl font-bold text-black "
                      >
                        Edit Slider
                      </Dialog.Title>
                    </div>
                  </div>
                  <form id="slider_form" className="py-5 mt-4 px-5">
                    <Input.Label
                      title={"Title"}
                      name="title"
                      id="title"
                      defaultValue={data.title}
                      onChange={handleChange}
                    />
                    {submitted && !title && (
                      <div className="text-primary text-xs ">
                        Title is required
                      </div>
                    )}
                    <Input.Label
                      title={"Description"}
                      name="description"
                      id="description"
                      defaultValue={data.description}
                      placeholder="Enter description"
                      onChange={handleChange}
                    />
                    <Input.Label
                      title={"Link/URL"}
                      name="url"
                      id="url"
                      defaultValue={data.url}
                      placeholder="Enter URL"
                      onChange={handleChange}
                    />

                    <div className="mt-8 mx-auto text-center max-w-[298px] bg-[#FFFBFA] p-5 border border-dashed border-[#E4E4F3] rounded-md cursor-pointer">
                      {imageUrls?.length > 0 ? (
                        imageUrls?.map((image, index) => (
                          <div key={index}>
                            <img
                              src={image}
                              className="object-cover w-full h-full"
                              alt="food"
                            />
                          </div>
                        ))
                      ) : (
                        <div>
                          <UploadIcon className="w-8 h-8 mx-auto mb-3" />
                          <p
                            className="text-[#676565]"
                            onClick={handleFileClick}
                          >
                            Click here to select a photo
                          </p>
                          <input
                            type="file"
                            className="hidden"
                            accept="image/*"
                            onChange={onImageChange}
                            ref={hiddenFileInput}
                          />
                        </div>
                      )}
                    </div>
                  </form>

                  <div className="py-8 max-w-3xl mx-auto text-center">
                    <Button.Primary
                      title={isLoading ? <Beat /> : "Edit Slider"}
                      className="px-4"
                      type={"button"}
                      onClick={() => handleSubmit()}
                    />
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </div>
  );
}
